import { Clock } from 'lucide-react';

/**
 * Final placeholder for the Billing sub-tab — this is Billing's only ticket
 * (see .scratch/engagement-metrics-dashboard/issues/04-billing-tab-scope.md).
 * No billable/non-billable breakdown content, no endpoint, no query this
 * phase; real content ships in a later monetary phase.
 */
export const EngagementMetricsBillingTab = () => {
  return (
    <div
      className="flex flex-col items-center justify-center py-16 text-center"
      data-testid="engagement-metrics-billing-tab"
    >
      <Clock className="h-8 w-8 text-gray-400 mb-3" />
      <p className="text-[13px] text-gray-500">Coming soon</p>
    </div>
  );
};
